import { set } from 'date-fns';

export function timeStringToTodayDate(time: string): Date {
  const [hours, minutes, seconds] = time.split(':').map(Number);

  return set(new Date(), {
    hours,
    minutes,
    seconds,
    milliseconds: 0,
  });
}
